import { useState } from 'react'

import { Check, Copy, ExternalLink } from 'lucide-react'

import {
    copyCurrentLink,
    getOpenInBrowserUrl,
    getPlatform,
} from '../../browserEnvironment'

// "Open in browser" + "Copy link" buttons, with manual steps as the always-available fallback
// (opening the browser from inside an email app doesn't work on every phone).
const OpenInBrowserActions = ({ onAction, compact = false }) => {

    const [copied, setCopied] = useState(false)
    const [copyFailed, setCopyFailed] = useState(false)

    const openUrl = getOpenInBrowserUrl()
    const platform = getPlatform()

    const handleOpen = () => {
        if (onAction) onAction('open_in_browser_clicked')
        window.location.href = openUrl
    }

    const handleCopy = async () => {
        if (onAction) onAction('copy_link_clicked')
        const ok = await copyCurrentLink()
        setCopied(ok)
        setCopyFailed(!ok)
        if (ok) setTimeout(() => setCopied(false), 3000)
    }

    const buttonSize = compact ? 'px-4 py-2 text-sm' : 'px-5 py-3 text-base'

    return (
        <div className="space-y-3">
            <div className="flex flex-col sm:flex-row gap-3">
                {openUrl && (
                    <button
                        type="button"
                        onClick={handleOpen}
                        className={`inline-flex items-center justify-center gap-2 rounded-xl bg-blue-600 hover:bg-blue-700 text-white font-semibold shadow-md transition-all ${buttonSize}`}
                    >
                        <ExternalLink className="w-4 h-4 shrink-0" />
                        {platform === 'ios' ? 'Open in Safari' : 'Open in Chrome'}
                    </button>
                )}
                <button
                    type="button"
                    onClick={handleCopy}
                    className={`inline-flex items-center justify-center gap-2 rounded-xl bg-gray-100 hover:bg-gray-200 text-gray-800 font-semibold transition-all ${buttonSize}`}
                >
                    {copied ? <Check className="w-4 h-4 shrink-0 text-green-600" /> : <Copy className="w-4 h-4 shrink-0" />}
                    {copied ? 'Link copied' : 'Copy link'}
                </button>
            </div>

            {copyFailed && (
                <p className="text-xs text-red-600 break-all">
                    Couldn't copy automatically. Copy this link: {window.location.href}
                </p>
            )}

            <div className="text-sm text-gray-600 space-y-1">
                <p className="font-medium text-gray-700">If the button doesn't work:</p>
                {platform === 'ios' ? (
                    <p>Tap the <strong>•••</strong> or <strong>Share</strong> icon and choose <strong>Open in Safari</strong>, or copy the link and paste it into Safari.</p>
                ) : (
                    <p>Tap the <strong>⋮</strong> menu at the top right and choose <strong>Open in Chrome</strong> (or <strong>Open in browser</strong>), or copy the link and paste it into your browser.</p>
                )}
            </div>
        </div>
    )
}

export default OpenInBrowserActions
